export type HomePageState = {
  searchDepartmentId: string;
  searchResult: {
    myProjectList: MyProject[];
    myTodoList: MyTodo[];
  };
};

export type MyProjectSpreadsheetState = {
  myProjectList: MyProject[];
};

export type MyTodoSpreadsheetState = {
  myTodoList: MyTodo[];
};

export type MyProject = {
  no: string;
  pjtType: string;
  pjtId: string;
  pjtName: string;
  pjtLnchType: string;
  status: string;
  pjtRegisteredDate: string;
  pjtStartedDate: string;
  dipByRgn: string;
  cpntId: string;
  jediPjtDesc: string;
  pjtOwner: string;
  transitionId: string;
  transitionPrm: { [key: string]: string };
  mmTxt: string;
  mmTxtUpdateDateTime: string;
};

export type MyTodo = {
  no: string;
  pjtId: string;
  pjtName: string;
  ticketType: string;
  tcktTypeCd: string;
  tcktStsTypeCd: string;
  status: string;
  transitionPrjId: string;
  transitionPrjPrm: { [key: string]: string };
  transitionId: string;
  transitionPrm: { [key: string]: string };
  transitionPageName: string;
  mmTxt: string;
  mmTxtUpdateDateTime: string;
};

export type PageNewState =
  | HomePageState
  | ((prevState: HomePageState) => HomePageState);
